<template>
  <div class="yoyo-container mx-auto pb-[env(safe-area-inset-bottom)]">
    <navBar :title="$t('products.payNavTitle')" />

    <!-- Content -->
    <div class="pb-4">
      <AddressForm ref="addressForm" :addressData="addressData" :showAddress="showAddress" @register-check="handleRegisterCheck" />
      <PayProduct :products="settleProducts" />
      <PaymentSummary
        :priceInfo="settlementData.price"
        :settlementDataErrCode="settlementDataErrCode"
        @reset="handleReset"
        @yoyo-used="handleYoYoUsed"
        @coupon-selected="handleCouponSelected" />
      <!-- <PaymentMethod :bankInfo="bankData" ref="paymentMethod" @payment-method-change="handlePaymentMethodChange" /> -->
    </div>


    <div class="h-17"></div>

    <!-- 结算按钮 -->
    <div class="fixed z-50 h-17 bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] yoyo-container mx-auto">
      <div class="flex items-center space-x-3 w-full h-17 lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-3 px-3">
        <div class="flex-1 text-right mr-4">
          <div class="text-lg font-bold text-[#ff7a00]">RM {{ formatToYuan(settlementData.price && settlementData.price.payPrice) }}</div>
          <div class="text-sm text-gray-500" v-if="isRegister != null && !isLoggedIn">
            <div v-if="isRegister == false" class="flex items-center justify-end">
              <van-button type="primary" size="mini" plain color="#ff7a00" @click="handleLogin">
                {{ $t("products.registerMember") }}
              </van-button>
              <span class="ml-1">{{ $t("products.registerMemberDiscount") }}</span>
            </div>
            <div v-if="isRegister == true" class="flex items-center justify-end">
              <van-button type="primary" size="mini" plain color="#ff7a00" @click="handleLogin">
                {{ $t("products.loginMember") }}
              </van-button>
              <span class="ml-1">{{ $t("products.loginMemberDiscount") }}</span>
              <span>{{ settlementData.givePoint }}</span>
              <span>{{ $t("products.yoyoCoins") }}</span>
            </div>
          </div>
        </div>

        <!-- 结算按钮 -->
        <van-button type="primary" class="rounded-xl w-24 h-8" color="#ff7a00" @click="handleCheckout">
          {{ $t("products.checkout") }}
        </van-button>
      </div>
    </div>

    <CommonDialog
      :visible.sync="waitingForPayment"
      :title="$t('pay.title')"
      :buttons="[{ text: $t('common.confirm'), type: 'primary', action: 'submit' }]"
      @button-click="handleWaitingForPaymentClose"
      @close="handleWaitingForPaymentClose">
      <div class="text-center">
        <div class="mb-4">
          {{ $t("pay.waitingForPayment") }}
        </div>
      </div>
    </CommonDialog>
    <CommonDialog
      :visible.sync="orderSuccess"
      :title="$t('pay.title')"
      :buttons="[{ text: $t('common.confirm'), type: 'primary', action: 'submit' }]"
      @button-click="handleOrderSuccess"
      @close="handleOrderSuccessClose">
      <div class="text-center">
        <div class="mb-4">
          {{ $t("pay.orderSuccess") }}
        </div>
      </div>
    </CommonDialog>
  </div>
</template>

<script>
import { Toast } from "vant"
import AddressForm from "@/components/products/AddressForm.vue"
import PayProduct from "@/components/products/PayProduct.vue"
import PaymentSummary from "@/components/products/PaymentSummary.vue"
import PaymentMethod from "@/components/products/PaymentMethod.vue"
import { mapGetters, mapMutations } from "vuex"
import { getDefaultAddress, getDefaultBank, getSettlement, createOrder, getOrderStatus } from "@/apis/pay"
import BigNumber from "bignumber.js"
import { formatToYuan } from "@/utils/common"

export default {
  name: "Pay",
  components: {
    AddressForm,
    PayProduct,
    PaymentSummary,
    PaymentMethod,
  },
  data() {
    return {
      backSrc: require("@/assets/images/back.png"),
      yoyoUsed: false, //是否使用YoYo币
      couponId: "", //优惠券id
      paymentData: null,
      addressData: null,
      bankData: null,
      showAddress: false,
      settleProducts: [], //结算商品
      settlementData: {},
      isRegister: null,
      formatToYuan,
      isLoading: false,
      settlementDataErrCode: "",
      orderId: "",
      waitingForPayment: false,
      orderSuccess: false,
      usePoint: 0,
      timer: null,
      startTime: null,
      count: 0,
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  methods: {
    ...mapMutations({
      setLoginDialogVisible: "auth/SET_LOGIN_DIALOG_VISIBLE",
    }),
    handleYoYoUsed(discount, isRefresh, usePoint) {
      this.yoyoUsed = discount
      this.usePoint = usePoint
      if (isRefresh) {
        this.getSettlementData()
      }
    },
    handleCouponSelected(coupon, isRefresh) {
      this.couponId = coupon
      if (isRefresh) {
        this.getSettlementData()
      }
    },
    handlePaymentMethodChange(paymentData) {
      this.paymentData = paymentData
      console.log("Payment method changed:", paymentData)
    },
    async handleCheckout() {
      if (this.isLoading) return

      // 验证地址表单
      if (!this.$refs.addressForm.validateForm()) {
        this.$toast(this.$t("products.completeShippingInfo"))
        return
      }

      // 验证支付方式
      // if (!this.$refs.paymentMethod.validatePayment()) {
      //   this.$toast(this.$t("products.completePaymentInfo"))
      //   return
      // }

      // 获取地址数据
      const addressData = this.$refs.addressForm.getFormData()

      // 获取支付数据
      // const paymentData = this.$refs.paymentMethod.getPaymentData()
      const paymentData = {}
      const items = this.settleProducts.map((item) => {
        return {
          skuId: item.sku,
          count: item.count,
          cartId: item.cartId || "",
        }
      })
      const params = {
        items: items, // 商品信息
        couponId: this.couponId || "", // 优惠券id
        usePoint: this.yoyoUsed ? this.usePoint : 0, // 是否使用YoYo币
        receiverAddress: addressData.address, // 收获地址
        receiverCountry: addressData.receiverCountry, // 收获国家
        receiverCity: addressData.receiverCity, // 收获城市
        receiverZipcode: addressData.receiverZipcode, // 收获邮编
        receiverName: addressData.name, // 收获人姓名
        receiverMobile: addressData.countryCode + " " + addressData.mobile, // 收获人手机号
        email: addressData.email, // 收获人邮箱
        receivePromotion: addressData.subscribeMarketing ? 1 : 0, // 是否订阅促销
        // bankName: paymentData.form.name, // 银行卡名称
        // bankCardNo: paymentData.form.cardNo, // 银行卡号
        // bankExpireDate: paymentData.form.expireDate, // 有效期
        // bankChecksum: paymentData.form.checksum, // 校验码
        // bankSave: paymentData.form.saveCard ? true : false, // 是否保存银行卡
      }
      Toast.loading({
        forbidClick: true,
        overlay: true,
        duration: 60000,
      })
      try {
        this.isLoading = true
        const orderData = await createOrder(params)
        console.log("订单数据:", orderData)
        this.orderId = orderData.data.id
        console.log("this.orderId :>> ", this.orderId)
        window.open(orderData.data.payUrl, "_blank")
        console.log("查询状态 :>> ")
        
        setTimeout(() => {
          this.waitingForPayment = true
          Toast.clear()
        }, 3000)
        // 10秒钟后开始查询订单状态
        this.startTime = setTimeout(() => {
          this.getOrderStatusFn()
        }, 10000)
      } catch (error) {
        Toast.clear()
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async getOrderStatusFn() {
      // 1秒钟查询一次,直到status为10或者查询次数为120结束
      try {
        // 1秒钟查询一次,直到status为10或者查询次数为120结束
        if (this.count >= 120) {
          clearTimeout(this.timer) // 清理定时器
          return
        }
        this.count++
        const res = await getOrderStatus({ id: this.orderId })
        if (res.data.status === 10) {
          this.waitingForPayment = false
          this.orderSuccess = true
          clearTimeout(this.timer) // 成功时清理定时器
          return
        }
        this.timer = setTimeout(() => {
          this.getOrderStatusFn()
        }, 1500)
      } catch (error) {
        console.log("error", error)
      }
    },
    async getDefaultData() {
      if (!this.isLoggedIn) {
        return
      }
      try {
        const addressData = await getDefaultAddress()
        // const bankData = await getDefaultBank()
        this.addressData = addressData.data
        // this.bankData = bankData.data
      } catch (error) {
        console.log(error)
      }
    },
    async getSettlementData() {
      this.settlementDataErrCode = ''
      // console.log('this.settleProducts :>> ', this.settleProducts);
      try {
        const items = this.settleProducts.map((item) => {
          if (item.type === "SIM") {
            this.showAddress = true
          }
          // console.log('item :>> ', item);
          return {
            skuId: item.sku,
            count: item.count,
            cartId: "",
          }
        })
        // console.log('items :>> ', items);
        const params = {
          items: items,
          couponId: this.couponId || "",
          usePoint: this.yoyoUsed ? this.usePoint : 0,
          receiverAddress: "",
        }
        const res = await getSettlement(params)
        let data = res.data || {}
        data.price.userPoint = res.data.userPoint
        this.settlementData = data
      } catch (error) {
        // console.log("error :>> ", error)
        const code = error.code
        this.settlementDataErrCode = code
        if (code === 'ECONNABORTED') {
          // this.settlementData.price ? (this.settlementData.price.payPrice = 0) : this.settlementData = { price: { payPrice: 0 } }
          this.handleReset()

          Toast.fail({
            message: this.$t("products.settleErr"),
            forbidClick: true,
            duration: 3000,
          })

        } 
        // this.settlementDataErrCode = code
        
      }
    },
    handleReset() {
      console.log('this.settlementData.price :>> ', this.settlementData.price);
      const price = this.settlementData.price || {}
      const totalPrice = price.totalPrice || 0
      const deliveryPrice = price.deliveryPrice || 0
      const payPrice = new BigNumber(totalPrice).plus(deliveryPrice).toNumber()
      this.settlementData.price ? (this.settlementData.price.payPrice = payPrice) : this.settlementData = { price: { payPrice: payPrice } }
    },
    handleRegisterCheck(isRegister) {
      this.isRegister = isRegister
    },
    handleLogin() {
      this.setLoginDialogVisible(true)
    },
    handleWaitingForPaymentClose() {
      this.waitingForPayment = false
    },
    handleOrderSuccess() {
      this.handleOrderSuccessClose()
      this.$router.push({
        name: "orderDetail",
        query: {
          orderId: this.orderId,
        },
      })
    },
    handleOrderSuccessClose() {
      this.orderSuccess = false
    },
  },
  watch: {},
  created() {
    this.getDefaultData()
    this.settleProducts = JSON.parse(localStorage.getItem("yoyotravel_settleData"))

    this.getSettlementData()
  },
  beforeDestroy() {
    console.log("清除定时器 :>> ")
    // 清除轮询查询
    clearTimeout(this.timer)
    clearTimeout(this.startTime)
  },
}
</script>

<style scoped></style>
